import { render, staticRenderFns } from "./CallTagDetail.vue?vue&type=template&id=06539309"
import script from "./CallTagDetail.vue?vue&type=script&lang=js"
export * from "./CallTagDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports